import React, { forwardRef } from 'react';
import styled from 'styled-components';
import StyledInput from '../../../app/components/styledComponents/StyledInput';
import SearchIcon from '../../../app/components/svgIcons/SearchIcon';
import CloseIcon from '../../../app/components/svgIcons/CloseIcon';

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: ${({ width }) => width || 'auto'};
  border-radius: 7px;
  border-color: ${({ theme }) => theme.gray40};
`;

const StyledIcon = styled.div`
  color: ${({ theme }) => theme.primary};
  border-radius: 2px;
  margin-left: -30px;
  display: flex;
  align-items: center;
  &.search-icon {
    z-index: 0;
    background-color: transparent;
    margin-top : 2px ;
    &.icon-small {
      margin-left: -28px;
    }
    &.dark40 {
      color: ${({ theme }) => theme.dark40 || theme.primary}!important;
    }
  }
`;

const SearchInput = forwardRef(
  (
    {
      value,
      setValue = () => {},
      className,
      hideIcon,
      placeHolder,
      searchIconClassName,
      stroke,
      styledIconProps = {},
      isClearable = true,
      size,
      onReset = () => {},
      SearchContainerClassName,
      svgSize,
      ...props
    },
    ref,
  ) => {
    svgSize = size === 'small' ? 20 : svgSize;
    return (
      <SearchContainer {...props} className={`position-relative ${SearchContainerClassName? SearchContainerClassName : ''}`}>
        <StyledInput
          type="text"
          placeholder={placeHolder || 'Search...'}
          value={value}
          onInput={(e) => setValue(e.target.value)}
          className={className}
          size={size}
          ref={ref}
          {...props}
        />
        {!hideIcon && (
          <StyledIcon
            className={searchIconClassName}
            {...styledIconProps}
            onClick={() => setValue('')}
          >
            {isClearable && value ? (
              <CloseIcon
                className="cursor-pointer"
                stroke={stroke}
                size={svgSize}
                onClick={onReset}
              />
            ) : (
              <SearchIcon size={svgSize} />
            )}
          </StyledIcon>
        )}
      </SearchContainer>
    );
  },
);

export default SearchInput;
